import styled, { x } from '@xstyled/styled-components';
import React, { useEffect, useState } from 'react';
import { t } from 'ttag';
import { Button } from '../buttons';
import { Flex } from '../flex/Flex';
import Pic from './pic_for_404.png';
import PointerImg from './bubble-pointer.svg';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';

const Pointer = styled(PointerImg)`
  position: absolute;
  height: 30px;
  top: 140px;
  left: -27px;
  transform: rotate(90deg);
`;

const selector = (s: TrainingState) => select(s, 'learnerPortalUrl');

export const NotFound = ({ btnTitle = 'To my courses' }) => {
  const [showBtn, setShowBtn] = useState(true);

  const { learnerPortalUrl } = useTrainingStore(selector);

  let RXD: unknown;

  try {
    if (window.document.referrer) {
      const preUrl = window?.document?.referrer;
      const domain = preUrl?.split('/')[2];

      if (domain !== 'localhost:8000' && domain !== 'www.easyllama.com') {
        RXD = (window.parent as unknown as Record<string, unknown>).RXD;
      }
    } else {
      RXD = (window.parent as unknown as Record<string, unknown>).RXD;
    }
  } catch (error) {
    // console.error('RXD:', error);
  }

  useEffect(() => {
    if (typeof RXD !== 'undefined') {
      setShowBtn(false);
    }
  }, []);

  return (
    <x.div
      backgroundColor="#FFFDE8"
      w="100%"
      h="100%"
      display="flex"
      alignItems="center"
      justifyContent={{ _: 'flex-end', sm: 'space-evenly' }}
      flexDirection={{ _: 'column', sm: 'row' }}
      gap="xxl"
    >
      <x.div>
        <Pointer />
        <Flex variant="list" gap="md">
          <x.h1
            color="#000"
            fontFamily="llama"
            fontWeight={700}
            lineHeight="5px"
          >
            {t`Oops`}!
          </x.h1>
          <x.p color="#000">{t`It looks like we got lost here`}</x.p>
          {showBtn && learnerPortalUrl ? (
            <Button
              style={{ padding: '14px' }}
              onClick={() => {
                window.location.href = learnerPortalUrl;
              }}
            >
              {btnTitle}
            </Button>
          ) : (
            <br />
          )}
        </Flex>
      </x.div>
      <x.div
        minWidth="45%"
        minHeight="55%"
        color="#000"
        backgroundImage={`url(${Pic})`}
        backgroundPosition="center"
        backgroundSize="contain"
        backgroundRepeat="no-repeat"
      ></x.div>
    </x.div>
  );
};
